import React from 'react'
import { Container } from '../landingpage/components/container';
import { Split } from '../landingpage/components/split';
import { Footer } from '../landingpage/components/footer';
import { ImageView } from '../landingpage/components/imageview';
import { Points } from '../landingpage/components/points';
import { Video } from '../landingpage/components/video';
import { Util } from '../fasades/util';
import './buildingagents.css';

export class BuildingAgents extends React.Component {
    render() {
        return (

            <>
            <title>Build AI Agents with Ease - LLM Training Made Simple | TigerCity.ai</title>
            <meta
                    name="description"
                    content="Watch how easy it is to build AI agents with TigerCity.ai. Our video demonstrates the simple 3-step process: give feedback, train, and see results. Discover why LLM training is easier and more reliable than traditional prompting."
            />
            <link rel="canonical" href={Util.getTigerCityUrl() + "docs/buildingagents"}/>

            <div className="scroll">
                <div className="document-view extraspace">
                    <Container>
                      <h1 className="heading">Building Agents</h1>
                      <Video src="/videos/buildingagents.mp4"/>
                    </Container>

                    <Container>
                    <Split reverse={ true } >
                        <Points>
                            {{ "heading"      : "Training LLMs sounds complicated, but in fact it's so much easier than prompting.",
                               "description"  : "Just three simple steps:",
                               "points"      : [
                                    {
                                        "header"      : "Give Feedback",
                                        "icon"        : "🤔",
                                        "description" : "Give your AI feedback like you would any team member"
                                    },
                                    {
                                        "header"      : "Train",
                                        "icon"        : "🏋️‍♀️",
                                        "description" : "Start training, and we optimize everything behind the scenes", 
                                    },
                                    {
                                        "header"      : "See Results",
                                        "icon"        : "🎯",
                                        "description" : "Watch your agent improve and become more reliable over time",
                                    }
                            ]}}
                        </Points>
                        <ImageView src="/images/problem.png"/>
                    </Split>
                    </Container>

                    <Container>
                    <Split>
                        <ImageView src="/images/user.png"/>
                        <Points>
                            {{ "heading": "Build AI Agents with Ease",
                               "points"     : [
                                    {
                                        "header"      : "Build with Freedom",
                                        "icon"        : "🛠️",
                                        "description" : "Use any technology stack you prefer - LangGraph, custom frameworks, or existing tools"
                                    },
                                    {
                                        "header"      : "Seamless API Integration", 
                                        "icon"        : "🔌",
                                        "description" : "Access and train models through our unified API - a drop-in replacement for OpenAI that works with your existing code"
                                    },
                                    {
                                        "header"      : "Full Ownership & Control",
                                        "icon"        : "🔐",
                                        "description" : "Retain complete ownership of your intellectual property and trained models - no vendor lock-in"
                                    },
                                    {
                                        "header"      : "Deploy Anywhere",
                                        "icon"        : "🚀",
                                        "description" : "Launch your agents on your own servers or through platforms like Ollama - total deployment flexibility"
                                    }
                            ]}}
                        </Points>
                    </Split>
                    </Container>
                </div>
                <Footer/>
            </div>
            </>

        )
        }
}

